import { render, staticRenderFns } from "./ModalVnptCA.vue?vue&type=template&id=8aa67b46&scoped=true"
import script from "./ModalVnptCA.vue?vue&type=script&lang=js"
export * from "./ModalVnptCA.vue?vue&type=script&lang=js"
import style0 from "./ModalVnptCA.vue?vue&type=style&index=0&id=8aa67b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa67b46",
  null
  
)

export default component.exports